import styled from "styled-components";

export const SubTaskDetailContainerStyled = styled.div`
  border-radius: 1rem;
  padding: 1.25rem;
  background: ${({ theme }) => theme.COLORS.WHITE_1};
  .title_wrap {
    margin-bottom: 25px;
    display: flex;
    align-items: center;
    column-gap: 20px;
    .title {
      margin-bottom: 26px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    }
    .title_detail {
      margin-bottom: 26px;
      font-size: ${({ theme }) => theme.FONT.SIZE.S18};
      font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
    }
  }
  .sec_row_wrap {
    width: 100%;
    display: flex;
    .sec_left {
      width: 50%;
      .sec_title {
        margin-bottom: 25px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      }
      .row_wrap {
        margin-bottom: 20px;
        display: flex;
        .row_title {
          width: 20%;
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        }
        .row_value {
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
        }
      }
    }
    .sec-right {
      flex: 1;
      .sec_title {
        margin-bottom: 25px;
        font-size: ${({ theme }) => theme.FONT.SIZE.S12};
        font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
      }
      .row_wrap {
        margin-bottom: 20px;
        display: flex;
        .row_title {
          width: 20%;
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_REGULAR};
        }
        .row_value {
          font-size: ${({ theme }) => theme.FONT.SIZE.S12};
          font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
        }
      }
    }
  }
  .subtask_wrap {
    display: flex;
    align-items: center;
    font-size: ${({ theme }) => theme.FONT.SIZE.S18};
    font-family: ${({ theme }) => theme.FONT.STYLE.KANIT_SEMIBOLD};
    .left_subtask {
      width: 20%;
    }
    .right_subtask {
      width: 155px;
    }
  }
  .table_layout {
    margin-bottom: 22px;
  }
  .btn_wrap {
    display: flex;
    justify-content: flex-end;
    .btn {
      width: 186px;
    }
  }
  .line {
    border-bottom: 1px solid ${({ theme }) => theme.COLORS.GRAY_11};
    margin-bottom: 23.5px;
  }
`;
